addEventListener('DOMContentLoaded', (t) => {
  if (!Utils.isCollectionPage) {
    const t = () => window.location.pathname.includes('/collections');
    Utils.isCollectionPage = t;
  }
  if (window.Analytics) {
    var e = 'boostPFSAnalytics',
      a = 'boostPFSSessionId',
      c = 'boostPFSClickedProduct',
      o = '',
      n = '',
      i = null,
      r = 'boostPFSRequestIds',
      l = {
        UserAction: {
          VIEW_PRODUCT: 'view_product',
          QUICK_VIEW: 'quick_view',
          ADD_TO_CART: 'add_to_cart',
          BUY_NOW: 'buy_now',
        },
        Action: { FILTER: 'filter', SEARCH: 'search', SUGGEST: 'suggest' },
      };
    (Analytics.initInstantSearch = function () {
      Settings.getSettingValue('search.enableSuggestion') &&
        (document.addEventListener('click', Analytics.onClickProductInSuggestion, !0),
        document.addEventListener('keydown', Analytics.onClickProductInSuggestion, !0));
    }),
      (Analytics.initCollectionSearchPage = function () {
        Selector.trackingProduct &&
          jQ(Selector.products).length > 0 &&
          document.addEventListener('click', Analytics.onClickProductInFilterResult, !0);
      }),
      (Analytics.initOtherPage = function () {
        var t = Analytics.getLocalStorage(e);
        Array.isArray(t) &&
          (t.forEach((t) => {
            Analytics.sendProductClickData(t, !0),
              t.pid == boostPFSAppConfig.general.product_id && (i = t);
          }),
          Utils.isProductPage() &&
            (Selector.trackingAddToCart &&
              document.addEventListener('click', Analytics.onClickAddToCartInProductPage, !0),
            Selector.trackingBuyNow &&
              document.addEventListener('click', Analytics.onClickBuyNowInProductPage, !0)),
          document.addEventListener('click', Analytics.detectClickFromRecommendation, !0));
      }),
      (Analytics.refreshCartToken = function (t, e = 3) {
        e <= 0 ||
          fetch('/cart.js', { method: 'GET', headers: { 'Content-Type': 'application/json' } })
            .then((t) => t.json())
            .then((a) => {
              a.token && a.token.length > 58
                ? ((o = a.token), t && ((t.ct = a.token), Analytics.sendProductClickData(t, !0)))
                : setTimeout(() => Analytics.refreshCartToken(t, e - 1), 1e3);
            })
            .catch((a) => {
              setTimeout(() => Analytics.refreshCartToken(t, e - 1), 1e3);
            });
      }),
      (Analytics.generateUUID = function () {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (t) {
          var e = (16 * Math.random()) | 0;
          return ('x' == t ? e : (3 & e) | 8).toString(16);
        });
      }),
      (Analytics.onClickProductInFilterResult = function (t) {
        if (t && t.target) {
          var e = jQ(t.target),
            a = Utils.isSearchPage() ? l.Action.SEARCH : l.Action.FILTER,
            c = l.UserAction.VIEW_PRODUCT;
          Selector.trackingQuickView &&
            e.closest(Selector.trackingQuickView).length > 0 &&
            (c = l.UserAction.QUICK_VIEW),
            ((Selector.trackingAddToCart && e.closest(Selector.trackingAddToCart).length > 0) ||
              (e.closest(Selector.products).length > 0 && Analytics.isClickAddToCart(t.target))) &&
              (c = l.UserAction.ADD_TO_CART),
            Selector.trackingBuyNow &&
              e.closest(Selector.trackingBuyNow).length > 0 &&
              (c = l.UserAction.BUY_NOW);
          var o = '',
            n = e.closest(Selector.trackingProduct);
          if (
            (n.length > 0
              ? (o = n.attr('data-id'))
              : i && ((c != l.UserAction.ADD_TO_CART && c != l.UserAction.BUY_NOW) || (o = i.pid)),
            o)
          ) {
            var r = Analytics.buildProductClickData(o, c, a);
            Analytics.addProductClickData(r),
              Analytics.sendProductClickData(r, !0),
              (i = c == l.UserAction.QUICK_VIEW ? r : null);
          }
        }
      }),
      (Analytics.onClickProductInSuggestion = function (t) {
        if (t && t.target && ('keydown' != t.type || 13 == t.keyCode)) {
          var e = jQ(t.target).closest('.' + Class.searchSuggestionItem + '-product');
          if (e) {
            var a = e.attr('data-id');
            if (a) {
              var c = Analytics.buildProductClickData(
                a,
                l.UserAction.VIEW_PRODUCT,
                l.Action.SUGGEST
              );
              Analytics.addProductClickData(c);
            }
          }
        }
      }),
      (Analytics.isClickAddToCart = function (t) {
        if (!t) return !1;
        ['SPAN', 'XVG'].includes(t.tagName) &&
          'BUTTON' === t.parentElement?.tagName &&
          (t = t.parentElement);
        const e = t?.outerHTML?.toLowerCase() || '';
        return [
          'boost-pfs-addtocart-btn',
          'customizeAdd',
          'add to cart',
          'add-to-cart',
          'add to bag',
          'add_to_cart',
          'addtocart',
          'data-product-form-add',
          'name="add"',
          'add to basket',
          'atc-button',
        ].some((t) => e.includes(t));
      }),
      (Analytics.onClickAddToCartInProductPage = function (t) {
        if (
          t &&
          t.target &&
          (jQ(t.target).closest(Selector.trackingAddToCart).length > 0 ||
            Analytics.isClickAddToCart(t.target))
        ) {
          var e = {
              tid: Globals.shopDomain,
              pid: boostPFSAppConfig.general.product_id.toString(),
              ct: o,
              r: document.referrer,
              u: l.UserAction.ADD_TO_CART,
            },
            a = Analytics.getLocalStorage(c) || {};
          a[boostPFSAppConfig.general.product_id] &&
            ((e = Object.assign(a[boostPFSAppConfig.general.product_id], e)),
            Analytics.addProductClickData(e),
            Analytics.sendProductClickData(e));
        }
      }),
      (Analytics.onClickBuyNowInProductPage = function (t) {
        if (t && t.target && jQ(t.target).closest(Selector.trackingBuyNow).length > 0) {
          var e = {
              tid: Globals.shopDomain,
              pid: boostPFSAppConfig.general.product_id.toString(),
              u: l.UserAction.BUY_NOW,
              ct: o,
            },
            a = Analytics.getLocalStorage(c) || {};
          a[boostPFSAppConfig.general.product_id] &&
            (((e = a[boostPFSAppConfig.general.product_id]).u = l.UserAction.BUY_NOW),
            Analytics.addProductClickData(e),
            Analytics.sendProductClickData(e));
        }
      }),
      (Analytics.buildProductClickData = (t, e, a) => {
        var n = new Date(),
          i = o,
          s = e == l.UserAction.QUICK_VIEW ? l.UserAction.VIEW_PRODUCT : e,
          d = '';
        if (
          (a == l.Action.FILTER
            ? (d += 'collection_scope=' + Globals.collectionId)
            : (d += 'q=' + Globals.currentTerm),
          a == l.Action.FILTER || a == l.Action.SEARCH)
        ) {
          var A = Object.keys(Globals.queryParams).filter((t) => t.startsWith(Globals.prefix));
          A &&
            A.length > 0 &&
            A.forEach((t) => {
              var e = Globals.queryParams[t];
              Array.isArray(e)
                ? e.forEach((e) => {
                    d += '&' + t + '=' + encodeURIComponent(e);
                  })
                : (d += '&' + t + '=' + encodeURIComponent(e));
            });
        }
        var u = Analytics.getLocalStorage(r),
          g = {
            tid: Globals.shopDomain,
            ct: i,
            pid: t,
            t: n.toISOString(),
            u: s,
            a,
            qs: d,
            r: document.referrer,
            rid: u[a]?.rid,
          },
          y = Analytics.getLocalStorage(c) || {};
        return Analytics.setLocalStorage(c, { [t]: { ...g }, ...y }), g;
      }),
      (Analytics.detectClickFromRecommendation = function (t) {
        if (t && t.target) {
          var e = jQ(t.target).closest('.boost-sd__product-item');
          if (e.length > 0) {
            var a = e[0].id,
              c = e[0]['data-product-id'];
            a && Analytics.removeProductIdClickedProductItemInRecommendation(a),
              c && Analytics.removeProductIdClickedProductItemInRecommendation(c);
          }
        }
      }),
      (Analytics.removeProductIdClickedProductItemInRecommendation = function (t) {
        var e = Analytics.getLocalStorage(c) || {};
        delete e[t], Analytics.setLocalStorage(c, { ...e });
      }),
      (Analytics.addProductClickData = function (t) {
        var a = Analytics.getLocalStorage(e);
        Array.isArray(a) || (a = []);
        var c = a.filter((e) => e.pid != t.productId);
        c.push(t), Analytics.setLocalStorage(e, c);
      }),
      (Analytics.removeProductClickData = function (t) {
        var a = Analytics.getLocalStorage(e);
        if (Array.isArray(a)) {
          var c = a.filter((e) => e.pid != t);
          Analytics.setLocalStorage(e, c);
        }
      }),
      (Analytics.getLocalStorage = function (t) {
        try {
          return JSON.parse(localStorage.getItem(t));
        } catch {
          return null;
        }
      }),
      (Analytics.setLocalStorage = function (t, e) {
        try {
          null != e ? localStorage.setItem(t, JSON.stringify(e)) : localStorage.setItem(t, '');
        } catch {}
      }),
      (Analytics.sendProductClickData = function (t, e) {
        if (t.rid)
          if (
            ([l.UserAction.ADD_TO_CART, l.UserAction.BUY_NOW].includes(t.u) && (e = !1), e || t.ct)
          ) {
            (t.sid = n), Analytics.removeProductClickData(t.pid);
            var a = new XMLHttpRequest();
            a.open('POST', Api.getApiUrl('analytics')),
              a.setRequestHeader('Content-Type', 'application/json;charset=UTF-8'),
              a.send(JSON.stringify(t));
          } else
            setTimeout(function () {
              Analytics.refreshCartToken(t);
            }, 1e3);
      }),
      (Analytics.getSessionId = function () {
        return (
          n ||
          ((n = Analytics.getLocalStorage(a)) ||
            ((n = Analytics.generateUUID()), Analytics.setLocalStorage(a, n)),
          n)
        );
      }),
      (Utils.isSearchPage() || (Utils.isCollectionPage() && !Utils.isProductPage())) &&
        (FilterApi.afterCall = function (t, e, a) {
          var c = l.Action.FILTER;
          Utils.isSearchPage() && (c = l.Action.SEARCH);
          var o = Analytics.getLocalStorage(r) || {};
          Analytics.setLocalStorage(r, { ...o, [c]: { rid: t?.meta?.rid, data: t } });
        }),
      (InstantSearchApi.afterCall = function (t) {
        var e = Analytics.getLocalStorage(r) || {};
        Analytics.setLocalStorage(r, { ...e, [l.Action.SUGGEST]: { rid: t?.meta?.rid, data: t } });
      }),
      (Analytics.init = function () {
        window.XMLHttpRequest &&
          ((o = ''),
          (n = Analytics.getLocalStorage(a)) ||
            ((n = Analytics.generateUUID()), Analytics.setLocalStorage(a, n)),
          Analytics.initInstantSearch(),
          Analytics.initCollectionSearchPage(),
          Analytics.initOtherPage());
      }),
      (window.Analytics = Analytics),
      setTimeout(function () {
        Analytics?.init(), console.log('Have customize tracking events for analytics V2');
      }, 1e3);
  } else console.log('This page have not tracking events for analytics V2');
});
